import { Component, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import {
	ActivatedRoute,
	NavigationEnd,
	Router,
	RouterLink,
	RouterOutlet
} from '@angular/router';
import { AppolowUcfirstPipe } from '@appolow/form';
import { Translations } from '@core/services';
import { TranslocoPipe } from '@jsverse/transloco';
import { upperFirst } from '@utils/strings';
import { MenuItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { Menu, MenuModule } from 'primeng/menu';
import { Tab, TabList, Tabs } from 'primeng/tabs';
import { filter, map, startWith } from 'rxjs';

@Component({
	selector: 'app-connections-wrapper',
	imports: [
		Tabs,
		TabList,
		Tab,
		RouterLink,
		RouterOutlet,
		TranslocoPipe,
		AppolowUcfirstPipe,
		ButtonModule,
		MenuModule
	],
	templateUrl: './connections-wrapper.component.html',
	host: {
		class: 'detail-page detail-page--container list-page list-page--container'
	}
})
export class ConnectionsWrapperComponent {
	#router = inject(Router);
	#route = inject(ActivatedRoute);

	protected readonly activeTab = toSignal(
		this.#router.events.pipe(
			filter((event) => event instanceof NavigationEnd),
			startWith(null),
			map(() => this.#route.firstChild?.routeConfig?.path)
		)
	);

	protected readonly addMenuItems = signal<MenuItem[]>([]);

	/** Fills the add menu with the available connection types, then opens it. */
	protected openAddMenu(event: Event, menu: Menu): void {
		const label = (key: string) => upperFirst(Translations.instant(key));
		this.addMenuItems.set([
			{
				label: label('CONNECTIONS.BUTTONS.DATABASES'),
				command: () => this.#navigate('databases')
			},
			{
				label: label('CONNECTIONS.BUTTONS.APIS'),
				command: () => this.#navigate('apis')
			},
			{
				label: label('CONNECTIONS.BUTTONS.STORAGE'),
				command: () => this.#navigate('storages')
			},
			{
				label: label('CONNECTIONS.BUTTONS.SMTP'),
				command: () => this.#navigate('smtps')
			},
			{
				label: label('CONNECTIONS.BUTTONS.BPMN'),
				command: () => this.#navigate('bpmns')
			}
		]);
		menu.toggle(event);
	}

	#navigate(type: string): void {
		this.#router.navigate([type, 'add'], { relativeTo: this.#route });
	}
}
